class MicroFrontend extends HTMLElement {
  static observedAttributes = ["url"];

  constructor() {
    super();
    this.attachShadow({ mode: "open" });
  }

  connectedCallback() {
    this.render();
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "url" && oldValue !== newValue) {
      this.url = newValue;
    }
  }

  render() {
    const container = document.createElement("div");
    container.id = "micro-frontend-container";
    this.shadowRoot.appendChild(container);

    // Random number to avoid caching
    const random = Math.random();

    // Load the micro frontend script and style
    const script = document.createElement("script");
    script.src = `${this.url}/bundle.js?random=${random}`;
    document.head.appendChild(script);

    const style = document.createElement("link");
    style.href = `${this.url}/main.css?random=${random}`;
    style.rel = "stylesheet";
    this.shadowRoot.appendChild(style);

    // Entry point for the micro frontend
    // InitializeMicroFrontend, defined in the micro frontend index.js root file
    script.onload = () => {
      if (window.initializeMicroFrontend) {
        window.initializeMicroFrontend(container);
      } else {
        console.error("initializeMicroFrontend is not defined");
      }
    };
  }
}

export default MicroFrontend;
